import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import HomePage from './pages/Home';
import CartPage from './pages/cart';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ProductDetail from './pages/products/ProductDetail';
import CustomBoxDetail from './pages/products/CustomBoxDetail';
import AllProducts from './pages/products/AllProducts';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { BranchProvider } from './context/BranchContext';
import { LanguageProvider } from './context/LanguageContext';
import CategoryPage from './pages/categories/CategoryPage';
import AllCategoriesPage from './pages/categories/AllCategoriesPage';
import OrderHistory from './pages/order/OrderHistory';
import MyAccount from './pages/account/MyAccount';
import SearchPage from './pages/search/SearchPage';
import './App.css';
import ScrollToTop from './components/scrollToTop';
import SpecialOrderProducts from './pages/products/SpecialOrderProducts';
import SectionPage from './pages/SectionPage';
// Import blog pages
import BlogPage from './pages/blog';
import BlogDetail from './pages/blog/BlogDetail';
// Import footer pages
import AboutUs from './pages/footer/AboutUs';
import ShippingPolicy from './pages/footer/ShippingPolicy';
import PaymentPolicy from './pages/footer/PaymentPolicy';
import PrivacyPolicy from './pages/footer/PrivacyPolicy';
import Contact from './pages/footer/Contact';
import MessengerFloatingButton from './components/MessengerFloatingButton';

const App: React.FC = () => {
  // Temporary: link to Zalo while Messenger popup is unavailable
  const ZALO_CHAT_URL = 'https://zalo.me/550666512965164320';

  return (
    <Router>
      <ScrollToTop />
      <LanguageProvider>
        <AuthProvider>
          <BranchProvider>
            <CartProvider>
              <Routes>
                <Route
                  path='/'
                  element={
                    <Layout>
                      <HomePage />
                    </Layout>
                  }
                />

                <Route
                  path='/products/:slug'
                  element={
                    <Layout>
                      <ProductDetail />
                    </Layout>
                  }
                />

                <Route
                  path='/products'
                  element={
                    <Layout>
                      <AllProducts />
                    </Layout>
                  }
                />

                <Route
                  path='/products/precut-fruit-box-gift'
                  element={
                    <Layout>
                      <SpecialOrderProducts />
                    </Layout>
                  }
                />

                <Route
                  path='/search'
                  element={
                    <Layout>
                      <SearchPage />
                    </Layout>
                  }
                />

                <Route
                  path='/custom-box/:slug'
                  element={
                    <Layout>
                      <CustomBoxDetail />
                    </Layout>
                  }
                />

                <Route
                  path='/categories'
                  element={
                    <Layout>
                      <AllCategoriesPage />
                    </Layout>
                  }
                />

                <Route
                  path='/categories/:categorySlug'
                  element={
                    <Layout>
                      <CategoryPage />
                    </Layout>
                  }
                />

                <Route
                  path='/products/category/:categorySlug'
                  element={
                    <Layout>
                      <CategoryPage />
                    </Layout>
                  }
                />

                <Route
                  path='/cart'
                  element={
                    <Layout>
                      <CartPage />
                    </Layout>
                  }
                />

                <Route
                  path='/auth/login'
                  element={
                    <Layout>
                      <Login />
                    </Layout>
                  }
                />

                <Route
                  path='/auth/register'
                  element={
                    <Layout>
                      <Register />
                    </Layout>
                  }
                />

                <Route
                  path='/order-history'
                  element={
                    <Layout>
                      <OrderHistory />
                    </Layout>
                  }
                />

                <Route
                  path='/account'
                  element={
                    <Layout>
                      <MyAccount />
                    </Layout>
                  }
                />

                <Route
                  path='/sections/:slug'
                  element={
                    <Layout>
                      <SectionPage />
                    </Layout>
                  }
                />

                {/* Blog Pages */}
                <Route
                  path='/blog'
                  element={
                    <Layout>
                      <BlogPage />
                    </Layout>
                  }
                />

                <Route
                  path='/blog/:id'
                  element={
                    <Layout>
                      <BlogDetail />
                    </Layout>
                  }
                />

                {/* Footer Pages */}
                <Route
                  path='/about-us'
                  element={
                    <Layout>
                      <AboutUs />
                    </Layout>
                  }
                />

                <Route
                  path='/shipping-policy'
                  element={
                    <Layout>
                      <ShippingPolicy />
                    </Layout>
                  }
                />

                <Route
                  path='/payment-policy'
                  element={
                    <Layout>
                      <PaymentPolicy />
                    </Layout>
                  }
                />

                <Route
                  path='/privacy-policy'
                  element={
                    <Layout>
                      <PrivacyPolicy />
                    </Layout>
                  }
                />

                <Route
                  path='/contact'
                  element={
                    <Layout>
                      <Contact />
                    </Layout>
                  }
                />
                {/* More routes will be added as they are developed */}
              </Routes>

              {/* Floating chat button (Zalo) */}
              <MessengerFloatingButton chatUrl={ZALO_CHAT_URL} />
            </CartProvider>
          </BranchProvider>
        </AuthProvider>
      </LanguageProvider>
    </Router>
  );
};

export default App;
